<template>
  <div v-loading.fullscreen="loading" :element-loading-text="loadingText" element-loading-spinner="el-icon-loading">
    <nav-basic :progress="60" :btn="false" title="Set the scene"></nav-basic>
    <b-container>
      <b-row class="step-header">
        <h2>Let’s add some photos</h2>
      </b-row>
      <b-row class="form-container">
        <span>People love photos and videos. It helps you get noticed and grab your clients attention.</span>

        <b-col md="6" class="text-center">
          <b-row class="mb-2">
            <b-button @click="next()"  style="padding:5px 30px; background-color:#e1251f; border:none;font-weight:bold"> + Add Media</b-button>
          </b-row class="step-navigator-buttons">
          <b-row class="mt-5 step-navigator-buttons">
            <b-col style="text-align:left;padding:0">
              <b-button @click="prev"  variant="outline-primary" class="btn-step-navigator">Back</b-button>
            </b-col>
            <b-col style="text-align:right;padding:0">
              <b-button @click="skip" variant="primary" class="btn-step-navigator">Skip for now</b-button>
            </b-col>
            <!-- <b-col style="text-align:right;padding:0">
              <b-button @click="test" variant="primary">test</b-button>
            </b-col> -->
          </b-row>
        </b-col>
        <b-col md="6"></b-col>
      </b-row>
    </b-container>
  </div>
</template>


<script>
  import {
    uploadImage,
    addListing,
    getUserUid
  } from '../functions.js'
  const h = this.$createElement;
  let save = false
  export default {
    data() {
      return {
        fileList2: [],
        dialogImageUrl: '',
        dialogVisible: false,
        loading: false,
        loadingText: '',
        pictureUrls: [],
        thumbUrls: []
      };
    },
    methods: {
      skip(){
        sessionStorage.setItem('sceneStatus', 1)
        sessionStorage.setItem('priceStatus', 0)
        this.$router.push({name:'price1'})
      },
      next() {
        this.$router.push({
          name: 'scene1',
        })
      },
      prev() {
        this.$router.push({
          name: 'addListing1',
        })
      }
    }
  }
</script>
<style scoped>
  @import '../assets/styles/add-steps.css';
</style>



// WEBPACK FOOTER //
// src/components/scene.vue